import BaseAction from './base.action';
import { ActionName, ActionTitle } from '../enums';
import api from '@/utils/api';

export default class RequestInfoAction extends BaseAction {
  name = ActionName.ViewListing;
  title = ActionTitle.RequestInfo;
  #user = null;

  constructor(config) {
    super(config);
    this.#user = config.user;
  }

  async execute(listing) {
    const isSent = await this.#createTicket(listing);

    this.propagateResult(listing, isSent);
  }

  #createTicket(listing) {
    const requestAddress = RequestInfoAction.#getListingAddress(listing);
    const fullName = `${this.#user.firstName} ${this.#user.lastName}`;
    const description = `
      Message sent from: ${fullName}
      Seller email: ${this.#user.email}
      Seller’s own listing ID: ${listing.listingId}
      Address they want to find out more about: ${requestAddress}
    `;
    const requestInfo = {
      subject: 'Additional sold information request from a seller',
      description,
      firstName: this.#user.firstName || '',
      lastName: this.#user.lastName || '',
      phone: this.#user.phone || '',
      email: this.#user.email || '',
    };

    return api.post('/questions', requestInfo);
  }

  static #getListingAddress({
    address, city, province, postal_code: postalCode,
  }) {
    return [address, city, province, postalCode].filter((value) => value).join(' ');
  }
}
